import React from "react";
import PropTypes from "prop-types";
import fordStyles from "../globalNavBar/GlobalNavBar.module.scss";
import lincolnStyles from "../globalNavBar/GlobalNavBar-Lincoln.module.scss";
import "../../styles/sharedStyles.scss";
import { Typography, Grid } from "@mui/material";
import { withTranslation } from "react-i18next";
import { IS_FORD_BRAND } from "../../utils/EmpUtil";
import EMPDialog from "../components/EMPDialog/EMPDialog";
import EMPCheckbox from "../components/EMPCheckbox/EMPCheckbox";

class ConfirmDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: props.open,
      checked: false,
    };
  }

  componentDidUpdate(prevProps) {
    const { open } = this.props;

    if (prevProps.open !== open) {
      this.setState({ open });
    }
  }

  changeCheckbox = () => {
    this.setState((prevState) => ({
      checked: !prevState.checked,
    }));
  };

  render() {
    const {
      showWarningIcon,
      dialogProps,
      showSettings,
      user,
      greenTitle,
      onClose,
      showOneButton,
      hideCancelAndConfirm,
      onConfirm,
      disableConfirm,
      additionalDescription,
      markupValue,
      laborRateValue,
      showWarning,
      dealerList,
      attributes,
    } = this.props;

    const { open, checked } = this.state;
    const isFordBrand = IS_FORD_BRAND(user?.brand);
    const styles = isFordBrand ? fordStyles : lincolnStyles;

    return (
      <EMPDialog
        open={open}
        dialogTitle={dialogProps?.title}
        titleType={greenTitle ? "success" : "warning"}
        hasCloseIcon={showWarningIcon}
        handleClose={onClose}
        hasSecondaryActionButton={!showOneButton && !hideCancelAndConfirm}
        secondaryActionButtonText={dialogProps?.cancel || "Cancel"}
        hasActionButton={!hideCancelAndConfirm}
        actionButtonText={dialogProps?.confirm || "Confirm"}
        onConfirm={onConfirm}
        disableActionButton={(showSettings && !checked) || disableConfirm}
        onSecondaryAction={onClose}
      >
        <Grid container id="deleteDialog" data-testid="confirmSaveSettings">
          <Grid item xs={12} className={styles.popupSection}>
            <Typography variant="body1">{dialogProps?.bodyText}</Typography>

            {additionalDescription && (
              <Typography variant="body1">
                {dialogProps?.additionalBodyText}
              </Typography>
            )}
          </Grid>

          {showSettings && (
            <Grid container className={styles.popupSection}>
              <Grid item xs={4} className={styles.settingsHeader}>
                <Typography variant="body1">{dialogProps?.markup}</Typography>
              </Grid>

              <Grid item xs={4} className={styles.settingsHeader}>
                <Typography variant="body1">
                  {dialogProps?.laborRate}
                </Typography>
              </Grid>

              <Grid item xs={4} />

              <Grid item xs={4} className={styles.settingsInfo}>
                <Typography variant="body1">{markupValue}%</Typography>
              </Grid>

              <Grid item xs={4} className={styles.settingsInfo}>
                <Typography variant="body1">${laborRateValue}</Typography>
              </Grid>
            </Grid>
          )}

          {showSettings && (
            <Grid item xs={12} className={styles.popupSection}>
              <EMPCheckbox
                checked={checked}
                name="checkboxBrandSettings"
                id="checkboxBrandSettings"
                label={dialogProps?.checkbox}
                handleChange={this.changeCheckbox}
              ></EMPCheckbox>
            </Grid>
          )}

          {showWarning && (
            <Grid
              item
              xs={12}
              data-testid="dealerList"
              className={styles.popupSection}
            >
              {dealerList.map((dealer) => {
                const attribute = attributes?.[dealer.commonId];

                return (
                  <div
                    key={dealer.dealerId}
                    className={styles.nonStyledListItem}
                  >
                    {dealer.name} ({dealer.dealerId + dealer.dealerSubcode}){" "}
                    {attribute}
                  </div>
                );
              })}
            </Grid>
          )}
        </Grid>
      </EMPDialog>
    );
  }
}

ConfirmDialog.propTypes = {
  open: PropTypes.bool,
  showWarningIcon: PropTypes.bool,
  dialogProps: PropTypes.shape({
    title: PropTypes.node,
    cancel: PropTypes.node,
    confirm: PropTypes.node,
    bodyText: PropTypes.node,
    additionalBodyText: PropTypes.node,
    markup: PropTypes.node,
    laborRate: PropTypes.node,
    checkbox: PropTypes.node,
  }),
  showSettings: PropTypes.bool,
  user: PropTypes.shape({
    brand: PropTypes.string,
  }),
  greenTitle: PropTypes.bool,
  onClose: PropTypes.func,
  showOneButton: PropTypes.bool,
  hideCancelAndConfirm: PropTypes.bool,
  onConfirm: PropTypes.func,
  disableConfirm: PropTypes.bool,
  additionalDescription: PropTypes.bool,
  markupValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  laborRateValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showWarning: PropTypes.bool,
  dealerList: PropTypes.arrayOf(
    PropTypes.shape({
      commonId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      dealerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      dealerSubcode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
    })
  ),
  attributes: PropTypes.objectOf(PropTypes.node),
};

ConfirmDialog.defaultProps = {
  open: false,
  showWarningIcon: false,
  dialogProps: null,
  showSettings: false,
  user: null,
  greenTitle: false,
  onClose: undefined,
  showOneButton: false,
  hideCancelAndConfirm: false,
  onConfirm: undefined,
  disableConfirm: false,
  additionalDescription: false,
  markupValue: "",
  laborRateValue: "",
  showWarning: false,
  dealerList: [],
  attributes: null,
};

export default withTranslation("emp")(ConfirmDialog);
